<template>
  <div v-if="$store.state.activeTabView === 'feedback'">
    <FeedbackForm />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FeedbackForm from '@/components/FeedbackForm.vue'

export default {
  components: {
    FeedbackForm,
  },
  computed: {
    ...mapState({
      activeTabView: (state) => state.activeTabView,
    }),
  },
}
</script>

<style lang="scss" scoped>
</style>
